import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { AuthHeading, AuthLayout } from "../features/auth/components/auth-layout";
import { SignUpForm } from "../features/auth/components/sign-up-form";
import { safeRedirect } from "../features/auth/guard";

export const Route = createFileRoute("/sign-up")({
  validateSearch: z.object({ redirect: z.string().optional() }),
  component: () => {
    const { redirect } = Route.useSearch();
    return (
      <AuthLayout>
        <AuthHeading
          title="Create your account"
          subtitle="Report bugs in one click, fix them without asking."
        />
        <SignUpForm redirect={safeRedirect(redirect)} />
      </AuthLayout>
    );
  },
});
